import React, { useState } from 'react';

import { HeroSection } from './components/heroSection/HeroSection';
import { ContactInfoCard } from './components/contactInfo/contachInfo';
import { ContactForm } from './components/contactForm/contactForm';
import NavBar from './components/Navbar/Navbar';
import { GoogleMapEmbed } from './components/MapSection/Map';
import FooterSection from './components/footer/footer';


const ContactUs = () => {
  return (
    <div className="min-h-screen relative z-0 bg-gray-50">
       <img src="/assets/img/bgGrid.png" className="absolute top-[-2em] left-0  h-auto w-auto sm:h-full sm:w-full   -z-10"/>
      <NavBar/>
      <HeroSection/>
      
      {/* Contact Section */}
      <section className="py-12 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
            <ContactInfoCard/>
            <ContactForm/>
          </div>
        </div>
      </section>
      <GoogleMapEmbed/>
      <FooterSection/>
    </div>
  );
};

export default ContactUs;